import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import styles from './ShoppingCart.module.css';
import ShoppingItem from '../components/shopping/ShoppingItem'

import { useShoppingCart } from '../context/ShoppingCartContext';
import storeProducts from '../data/products.json';

function ShoppingCart() {
    const { cartItems } = useShoppingCart();
    const [isEmpty, setIsEmpty] = useState(true);
    let totalValue = 0;
    let totalProductValue = 0;
    let productValue = 0;
    let tax = 20.0
    
    useEffect(() => {
        setIsEmpty(cartItems.length === 0?true:false);
    }, [cartItems]);
    
    function calculateProductTotal(item) {
        productValue = (item.quantity * storeProducts.filter(product => product.id === item.id)[0]['price'])
        totalProductValue += productValue
    }

    cartItems.map(item => (
        calculateProductTotal(item)
    ));

    totalValue = (totalProductValue + tax);
    
    return(
        <div className={styles.container}>
            <div className={styles.cart_container}>
                {!isEmpty && cartItems.map(item => (
                    <ShoppingItem 
                        key={item.id}
                        {...item}
                    />  
                ))
                }
                {isEmpty && 
                    <div className={styles.msg}>
                        <p>Seu carrinho está vazio!</p>
                        <Link to="/" className={styles.goback_button}>
                            <p>Continuar comprando</p>
                        </Link>
                    </div>
                }
            </div>
            {!isEmpty &&
                <div className={styles.payment_container}>
                    <span className={styles.title}>
                        <p>RESUMO</p>
                    </span>
                    <div className={styles.payment_fields}>
                        <span className={styles.payment_info}>
                            <p>Total dos produtos</p>
                            <span className={styles.value}>
                                <p>R$ {(Math.round(totalProductValue * 100) / 100).toFixed(2)}</p>
                            </span>
                        </span>
                        <span className={styles.payment_info}>
                            <p>Frete</p>
                            <span className={styles.value}>
                                <p>R$ {(Math.round(tax * 100) / 100).toFixed(2)}</p>
                            </span>
                        </span>
                    </div>
                    <div className={styles.total_fields}>
                        <span className={styles.total_info}>
                            <p>Total a pagar</p>
                            <span className={styles.total_value}>
                                <p>R$ {(Math.round(totalValue * 100) / 100).toFixed(2)}</p>
                            </span>
                        </span>
                    </div>
                    <div className={styles.button_fields}>
                        <Link to="/" className={styles.finish_button}>
                            <p>Ir para o pagamento</p>
                        </Link>
                    </div>
                </div>
            }
        </div>
    );   
}

export default ShoppingCart;